import { get } from 'features/api';
import { ClientVerificationResponse } from '../types';

const CLIENT_VERIFICATION_ENDPOINT = 'client';

export function* requestClientVerification() {
  return yield* get<ClientVerificationResponse>(
    CLIENT_VERIFICATION_ENDPOINT,
    {},
    {
      withCredentials: true,
    },
  );
}
